export default "__VITE_ASSET__BM3iL$TX__"